export const enum KEYS {
  C = 'C',
  X = 'X',
  Z = 'Z',
  Y = 'Y',
  A = 'A',
  G = 'G',
  L = 'L',
  F = 'F',
  D = 'D',
  B = 'B',
  P = 'P',
  O = 'O',
  R = 'R',
  T = 'T',
  MINUS = '-',
  EQUAL = '=',
  DIGIT_0 = '0',
  DELETE = 'DELETE',
  UP = 'ARROWUP',
  DOWN = 'ARROWDOWN',
  LEFT = 'ARROWLEFT',
  RIGHT = 'ARROWRIGHT',
  ENTER = 'ENTER',
  SPACE = ' ',
  TAB = 'TAB',
  BACKSPACE = 'BACKSPACE',
  ESC = 'ESCAPE',
  PAGEUP = 'PAGEUP',
  PAGEDOWN = 'PAGEDOWN',
  F5 = 'F5',
}

export const HOTKEY_DOC = [
  {
    type: 'General',
    children: [
      { label: 'Cut', value: 'Ctrl + X' },
      { label: 'Copy', value: 'Ctrl + C' },
      { label: 'Paste', value: 'Ctrl + V' },
      { label: 'Paste as plain text', value: 'Ctrl + Shift + V' },
      { label: 'Duplicate', value: 'Ctrl + D' },
      { label: 'Select all', value: 'Ctrl + A' },
      { label: 'Undo', value: 'Ctrl + Z' },
      { label: 'Redo', value: 'Ctrl + Y' },
      { label: 'Delete', value: 'Delete / Backspace' },
      { label: 'Multi-select', value: 'Hold Ctrl or Shift' },
      { label: 'Find and replace', value: 'Ctrl + F' },
      { label: 'Print', value: 'Ctrl + P' },
      { label: 'Close dialog', value: 'ESC' },
    ],
  },
  {
    type: 'Slide Show',
    children: [
      { label: 'Start presentation from beginning', value: 'F5' },
      { label: 'Start presentation from current slide', value: 'Shift + F5' },
      { label: 'Previous slide', value: '↑ / ← / PgUp' },
      { label: 'Next slide', value: '↓ / → / PgDown' },
      { label: 'Next slide', value: 'Enter / Space' },
      { label: 'Exit presentation', value: 'ESC' },
    ],
  },
  {
    type: 'Slide Editing',
    children: [
      { label: 'New slide', value: 'Enter' },
      { label: 'Move canvas', value: 'Space + drag mouse' },
      { label: 'Zoom canvas', value: 'Ctrl + mouse wheel' },
      { label: 'Zoom in', value: 'Ctrl + =' },
      { label: 'Zoom out', value: 'Ctrl + -' },
      { label: 'Fit canvas to screen', value: 'Ctrl + 0' },
      { label: 'Previous slide (no selection)', value: '↑' },
      { label: 'Next slide (no selection)', value: '↓' },
      { label: 'Previous slide', value: 'Mouse scroll up / PgUp' },
      { label: 'Next slide', value: 'Mouse scroll down / PgDown' },
      { label: 'Quick create text', value: 'Double click / T' },
      { label: 'Quick create rectangle', value: 'R' },
      { label: 'Quick create circle', value: 'O' },
      { label: 'Quick create line', value: 'L' },
      { label: 'Exit drawing mode', value: 'Right click' },
    ],
  },
  {
    type: 'Element Operations',
    children: [
      { label: 'Move', value: '↑ / ← / ↓ / →' },
      { label: 'Lock', value: 'Ctrl + L' },
      { label: 'Group', value: 'Ctrl + G' },
      { label: 'Ungroup', value: 'Ctrl + Shift + G' },
      { label: 'Bring to front', value: 'Alt + F' },
      { label: 'Send to back', value: 'Alt + B' },
      { label: 'Lock aspect ratio', value: 'Hold Ctrl or Shift' },
      { label: 'Create horizontal/vertical lines', value: 'Hold Ctrl or Shift' },
      { label: 'Switch focus element', value: 'Tab' },
      { label: 'Confirm image crop', value: 'Enter' },
      { label: 'Complete custom shape drawing', value: 'Enter' },
    ],
  },
  {
    type: 'Table Editing',
    children: [
      { label: 'Focus next cell', value: 'Tab' },
      { label: 'Move focus cell', value: '↑ / ← / ↓ / →' },
      { label: 'Insert row above', value: 'Ctrl + ↑' },
      { label: 'Insert row below', value: 'Ctrl + ↓' },
      { label: 'Insert column left', value: 'Ctrl + ←' },
      { label: 'Insert column right', value: 'Ctrl + →' },
    ],
  },
  {
    type: 'Chart Data Editing',
    children: [
      { label: 'Focus next row', value: 'Enter' },
    ],
  },
  {
    type: 'Text Editing',
    children: [
      { label: 'Bold', value: 'Ctrl + B' },
      { label: 'Italic', value: 'Ctrl + I' },
      { label: 'Underline', value: 'Ctrl + U' },
      { label: 'Inline code', value: 'Ctrl + E' },
      { label: 'Superscript', value: 'Ctrl + ;' },
      { label: 'Subscript', value: `Ctrl + '` },
      { label: 'Select paragraph', value: `ESC` },
    ],
  },
]
